import React from "react";
import "./addfoulmodal.css";

const AddFoulModal = (props) => {
  if (!props.visible) return null;

  return (
    <div className="overlay-addModal" onClick={props.onBackdropPress}>
      <div
        className="modal-container-addModal"
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside the modal from closing it
      >
        <h2 className="modal-heading-addModal">{props.foulModalHeading}</h2>

        <input
          type="text"
          placeholder="Enter foul description"
          className="modal-input-addModal"
          value={props.newFoul}
          onChange={(e) => props.setNewFoul(e.target.value)}
        />

        <div className="modal-btn-group-addModal">
          <button className="cancel-btn-addModal" onClick={props.onBackdropPress}>
            Cancel
          </button>
          <button className="save-btn-addModal" onClick={props.handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFoulModal;
